import dynamic from 'next/dynamic';
import { Fragment } from 'react';

import { DecoratorWrapper } from '@natu/ui/Decorators/DecoratorWrapper';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import { type SBProps, type BlokItem, sbEditable, DynamicRender } from '../../../../utils';

const Separator = dynamic(() => import('@natu/ui/Decorators/Separator').then(mod => mod.Separator));

interface SBErrorProps {
  body?: BlokItem[];
  links?: BlokItem[];
}

export const SBError = ({ blok }: SBProps<SBErrorProps>) => {
  const { body, links } = blok;

  return (
    <section className="bg-errorNotFound flex min-h-svh items-center justify-center">
      <div className="mx-auto max-w-screen-xl overflow-visible px-4 md:px-6 lg:px-8">
        <DecoratorWrapper variant="error" {...sbEditable(blok)}>
          <div className="relative z-[1]">
            <DynamicRender data={body} />
            {isArrayWithLength(links) && (
              <nav className="flex flex-col items-center justify-center gap-2 md:flex-row md:gap-10">
                {links.map((link, i) => (
                  <Fragment key={link._uid}>
                    <DynamicRender data={link} />
                    {i < links.length - 1 && (
                      <Separator
                        className="bg-naturaily-airborne h-8 rotate-90 opacity-50 md:rotate-0"
                        orientation="vertical"
                      />
                    )}
                  </Fragment>
                ))}
              </nav>
            )}
          </div>
        </DecoratorWrapper>
      </div>
    </section>
  );
};
